import { injectable } from 'inversify';
import { EventStreamListener } from '@/app/event-stream/event-stream-listener';
import {
  SectionInteractionEvent,
  StatisticsUpdatedEventName
} from '@/app/statistics/events/section-interaction-events';
//import { QuizEvent, QuizCompletedEventName } from '@/app/quiz/events/quiz-events';
import { AspectEvent, AspectInstanceChangedEventName } from '@/app/aspect/events/aspect-events';
import { CompetenceEvent, CompetenceUpdatedEventName } from '@/app/competence/events/competence-events';
import dashboardStoreModule from '../dashboard-state';

type HandledEvent = SectionInteractionEvent|/*QuizEvent|*/AspectEvent|CompetenceEvent;

@injectable()
export class ClearDashboardState implements EventStreamListener {
  public get events(): string[] {
    return [
      StatisticsUpdatedEventName,
//      QuizCompletedEventName,
      AspectInstanceChangedEventName,
      CompetenceUpdatedEventName
    ];
  }

  public handle(event: HandledEvent): void {
    dashboardStoreModule.setDashboard(null);
  }
}
